import PerfectScrollbar from 'perfect-scrollbar'
import * as React from 'react'
import {forwardRef} from 'react'
import ReactPerfectScrollbar, {ScrollBarProps} from 'react-perfect-scrollbar'
import ScrollBar from 'react-perfect-scrollbar'
import ScrollArea, {ScrollAreaProps} from 'react-scrollbar'
import {Util} from 'yougile-util'
import {updateRef} from '@containers/element-utils'
import {globals} from '@extensions/globals-base'
import {DragPerfectScrollbar} from './drag-perfect-scrollbar'
import {ScrollDirection} from './types'

export interface ScrollAreaContext {
  scrollTop(): void
  scrollBottom(): void
  scrollLeft(): void
  scrollRight(): void
  scrollYTo(topPosition: number): void
  scrollXTo(leftPosition: number): void
}

export interface ScrollProps extends ScrollBarProps {
  scrollDirection?: ScrollDirection
  drag?: boolean
  wheelPropagation?: boolean
  wheelSpeed?: number
  forceCustomScroll?: boolean
}

// In case of issues w/ infinite scrolling check if there are borders somewhere
// (see https://github.com/mdbootstrap/perfect-scrollbar/issues/51)

export const WithPerfectScrollbar = forwardRef<ScrollBar, ScrollProps>(
  (props, forwardedRef) => {
    const {
      scrollDirection = 'y',
      drag,
      wheelPropagation,
      wheelSpeed = 1,
      forceCustomScroll = false,
      ...otherProps
    } = props
    if (Util.isMac() && !globals.devMode && !drag && !forceCustomScroll) {
      return (
        <div
          {...otherProps}
          ref={el => el && props.containerRef?.(el)}
          style={{overflow: 'auto', ...otherProps.style}}
          onScroll={e => {
            props.onScroll?.(e)
            props.onScrollX?.(e.target as HTMLElement)
            props.onScrollY?.(e.target as HTMLElement)
          }}
        />
      )
    }

    const options: PerfectScrollbar.Options = {
      wheelPropagation,
      minScrollbarLength: 30,
      suppressScrollX: scrollDirection === 'y',
      suppressScrollY: scrollDirection === 'x',
      wheelSpeed: wheelSpeed
    }

    if (drag) {
      return (
        <DragPerfectScrollbar
          options={options}
          scrollDirection={scrollDirection}
          {...otherProps}
        />
      )
    }

    return (
      <ReactPerfectScrollbar
        ref={x => updateRef(x, forwardedRef)}
        options={options}
        {...otherProps}
      />
    )
  }
)

/**
 * @deprecated
 * Use `WithPerfectScrollbar` instead
 */
export const WithScrollbar = (props: ScrollAreaProps) => {
  return (
    <ScrollArea
      speed={0.8}
      horizontal={false}
      verticalScrollbarStyle={{borderRadius: '8px', minHeight: '16px'}}
      {...props}
    />
  )
}
